
<div>
    <f-title :title="$t('contract.termsOfCancelation') " v-if="showTitle" />
    <v-row class="no-frame"  >
        <v-col class="no-frame col-4 pr-2" v-show="monthsNeeded">
            <v-text-field
                :label         = "$t('contract.toc.months')"
                v-model        = "contract.tocMonths"
                :rules         = "[ monthRule ]"
                :readonly      = "readonly"
                autocomplete   = "off"
                autocorrect    = "off"
                autocapitalize = "off"
                spellcheck     = "false"
                type         = "number"
            />
        </v-col>
        <v-col class="no-frame" :class="monthsNeeded ? 'pl-2' : ''">
            <f-enum-select
                v-model   = "contract.tocType"
                :label    = "$t('contract.toc.until')"
                :rules    = "[ tocTypeRule ]"
                :readonly = "readonly"
                module    = "msd"
                type      = "contractTocType"
            />
        </v-col>
    </v-row>
    <v-row class="no-frame"  >
        <v-textarea
            class          = "pt-0"
            v-model        = "contract.tocComment"
            rows           = "3"
            :readonly      = "readonly"
            autocomplete   = "off"
            autocorrect    = "off"
            autocapitalize = "off"
            spellcheck     = "false"
            no-resize
            hide-details
        />
    </v-row>
    <v-row class="no-frame"  >
        <v-col class="no-frame col-6">
            <v-checkbox
                v-model   = "contract.tocRewal"
                :label    = "$t('contract.toc.renewal.automatic')"
                :ripple   = "false"
                :readonly = "readonly"
                style     = "margin-top:16px"
                hide-details
            />
        </v-col>
        <v-col class="no-frame col-2 pr-2">
            <v-text-field
                v-show="contract.tocRewal"
                v-model        = "contract.tocRenewalDuration"
                :label         = "$t('contract.toc.renewal.duration')"
                :readonly      = "readonly"
                :rules         = "[ renewalRule ]"
                autocomplete   = "off"
                autocorrect    = "off"
                autocapitalize = "off"
                spellcheck     = "false"
                type           = "number"
            />
        </v-col>
        <v-col class="no-frame pl-2">
            <f-enum-select
                v-show="contract.tocRewal"
                v-model   = "contract.renewalType"
                :label    = "$t('contract.toc.renewal.period')"
                :rules    = "[ renewalTypeRule ]"
                :readonly = "readonly"
                module    = "msd"
                type      = "contractRenewalType"
            />
        </v-col>
    </v-row>
    <!--
    <v-row class="no-frame" v-show="contract.tocRewal">
        <v-col class="no-frame col-4 pr-2">
            <v-text-field
                v-model        = "contract.tocRenewalDuration"
                :label         = "$t('contract.toc.renewal.duration')"
                :readonly      = "readonly"
                :rules         = "[ renewalRule ]"
                autocomplete   = "off"
                autocorrect    = "off"
                autocapitalize = "off"
                spellcheck     = "false"
                type           = "number"
            />
        </v-col>
        <v-col class="no-frame pl-2">
            <f-enum-select
                v-model   = "contract.renewalType"
                :label    = "$t('contract.toc.renewal.period')"
                :rules    = "[ renewalTypeRule ]"
                :readonly = "readonly"
                module    = "msd"
                type      = "contractRenewalType"
            />
        </v-col>
    </v-row>
    -->
</div>
